import React, { useState, useEffect, useCallback } from 'react'
import ImageSupplierPatterns from './ImageSupplierPatterns'
import { requestAPI, get } from '../../data/api.js'
import Input from '../../generic/Input'
import Button from '../../generic/Button'

export default function IncludeDomains(props) {
	const { clientId } = props
	const [includeDomains, setIncludeDomains] = useState('')

	const fetchClientIncludeDomains = useCallback(async () => {
		const includeDomains = await getClientIncludeDomains(clientId)
		setIncludeDomains(includeDomains)
	}, [clientId])

	useEffect(() => {
		fetchClientIncludeDomains(clientId)
	}, [clientId, fetchClientIncludeDomains])

	const handleSaveIncludeDomains = async () => {
		await updateClientIncludeDomains(clientId, includeDomains)
		await fetchClientIncludeDomains(clientId)
	}

	return (
		<div>
			<h2 style={{marginTop: '30px', marginBottom: '20px'}}>Include violations</h2>
			<div>
				<p>Include violations with one of the following domains in their URL</p>
				<Input
					name='includeDomains'
					placeholder='.se,facebook.com'
					value={includeDomains}
					onChange={e => setIncludeDomains(e.target.value)}
				/>
				<Button onClick={handleSaveIncludeDomains}>Save</Button></div>
			<div>
				<ImageSupplierPatterns clientId={clientId} />
			</div>
		</div>
	)
}

function getClientIncludeDomains(clientId) {
	return get(`/include-domains/${clientId}`, 'GET')
}

function updateClientIncludeDomains(clientId, domains) {
	return requestAPI(`/include-domains/${clientId}`, 'PUT', { domains })
}
